import React, { Suspense, lazy } from 'react'
import { BrowserRouter, Route, Routes } from 'react-router-dom'
import './scss/style.scss'
import './scss/main.css'
import 'react-toastify/dist/ReactToastify.css'
import 'react-multi-carousel/lib/styles.css'
import { ToastContainer } from 'react-toastify'
import Protected from './authorization/Protected'  // ← ADD THIS IMPORT

// Lazy load ALL components that aren't immediately needed on first load
const TeacherCool = lazy(() => import('./layout/TeacherCool'))
const ForgotPassword = lazy(() => import('./Views/pages/forgot/ForgotPassword'))
const TeacherLogin = lazy(() => import('./Teacher/TeacherAuth/TeacherLogin'))
const TeacherRegister = lazy(() => import('./Teacher/TeacherAuth/TeacherRegister'))
const SearchedContent = lazy(() => import('./layout/SearchedContent'))
const SubLogin = lazy(() => import('./Views/pages/login/SubLogin'))
const VerifyEmail = lazy(() => import('./Views/pages/Verify/VerifyEmail'))
const ForgetPassPage = lazy(() => import('./Views/pages/forgot/ForgetPassPage'))
const OrderWithUs = lazy(() => import('./layout/OrderWithUs'))
const ForgetPassUser = lazy(() => import('./Views/pages/forgot/ForgetPassUser'))
const ForgetPassUserPage = lazy(() => import('./Views/pages/forgot/ForgetPassUserPage'))
const ProfileReview = lazy(() => import('./layout/TeacherRequest/ProfileReview'))
const Ordersearch = lazy(() => import('./layout/Ordersearch'))
const StudentLanding = lazy(() => import('./Student/student-landing-page/StudentLanding'))
const StudentPricing = lazy(() => import('./Student/StudentPricing'))
const PaymentMessage = lazy(() => import('./Views/pages/PaymentMessage/PaymentMessage'))
const Checkout = lazy(() => import('./Views/pages/PaymentMessage/Checkout'))
const StudentChangePassword = lazy(() => import('./Student/StudentChangePassword'))
const StudentProfile = lazy(() => import('./Student/StudentProfile'))
const StudentOrder = lazy(() => import('./Student/StudentOrder'))
const StudentViewAssignments = lazy(() => import('./Student/Pages/ViewAssignments'))
const Careers = lazy(() => import('./Student/Pages/Careers'))
const AboutUs = lazy(() => import('./Student/Pages/AboutUs'))
const Home = lazy(() => import('./Student/HeadersTab/Home'))
const Question = lazy(() => import('./Student/HeadersTab/Question'))
const ViewCarrerDetails = lazy(() => import('./Student/Pages/ViewCarrerDetails'))
const HeaderArticle = lazy(() => import('./layout/HeaderArticle'))
const ReadmoreArticle = lazy(() => import('./layout/ReadmoreArticle'))
const Chat = lazy(() => import('./Student/HeadersTab/Chat'))
const Meeting = lazy(() => import('./Zoom/Meeting'))
const StudentNotification = lazy(() => import('./Student/HeadersTab/StudentNotification'))
const MeetingScheduleList = lazy(() => import('./Zoom/MeetingScheduleList'))
const PaymentInvoice = lazy(() => import('./Views/superAdmin/managepayment/PaymentInvoice'))
const Rewards = lazy(() => import('./Student/HeadersTab/Rewards'))
const SellerRegister = lazy(() => import('./seller/SellerRegister'))
const SellerLogin = lazy(() => import('./seller/SellerLogin'))
const OrderwithusList = lazy(() => import('./layout/OrderwithusList'))
const CopyRightPolicy = lazy(() => import('./PrivacyStatements/CopyRightPolicy'))
const CopyrightTakedownRequest = lazy(() => import('./PrivacyStatements/CopyrightTakedownRequest'))
const GeneralPolicies = lazy(() => import('./PrivacyStatements/GeneralPolicies'))
const HonorCode = lazy(() => import('./PrivacyStatements/HonorCode'))
const TeacherCoolPrivacyPolicy = lazy(() => import('./PrivacyStatements/TeacherCoolPrivacyPolicy'))
const TermsOfUse = lazy(() => import('./PrivacyStatements/TermsOfUse'))
const DefaultLayout = lazy(() => import('./layout/DefaultLayout'))
const Login = lazy(() => import('./Views/pages/login/Login'))
const Page500 = lazy(() => import('./Views/pages/page500/Page500'))

// Loading component for Suspense fallback
const LoadingFallback = () => (
  <div style={{
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    height: '100vh',
    fontSize: '18px',
    color: '#4CAF50'
  }}>
    <div>
      <div className="spinner-border text-success" role="status">
        <span className="visually-hidden">Loading...</span>
      </div>
      <p style={{ marginTop: '10px' }}>Loading...</p>
    </div>
  </div>
)

const App = () => {
  return (
    <BrowserRouter basename="/">
      <ToastContainer
        limit={1}
        autoClose={3000}
        hideProgressBar={false}
        closeOnClick={true}
        pauseOnHover={true}
        draggable={true}
        type={'type'}
      />
      <Suspense fallback={<LoadingFallback />}>
        <Routes>
          {/* Public Routes - No Authentication Required */}
          <Route exact path="/" name="Teacher Cool" element={<TeacherCool />} />
          <Route exact path="/admin/login" name="Login Page" element={<Login />} />
          <Route exact path="/sub-admin/login" name="Login Page" element={<SubLogin />} />
          <Route exact path="/login" name="TeacherLogin" element={<TeacherLogin />} />
          <Route
            exact
            path="/login/linkedin/:type?"
            name="TeacherLogin"
            element={<TeacherLogin />}
          />
          <Route exact path="/register" name="TeacherRegister" element={<TeacherRegister />} />
          <Route exact path="/verify/:id" name="verify" element={<VerifyEmail />} />
          <Route
            exact
            path="/content/:name?"
            name="TeacherRegister"
            element={<SearchedContent />}
          />
          <Route
            exact
            path="/meetingschedulelist"
            name="TeacherRegister"
            element={<MeetingScheduleList />}
          />
          <Route
            exact
            path="admin/forgotpassword"
            name="ForgotPassword Page"
            element={<ForgotPassword />}
          />
          <Route
            exact
            path="/admin/reset-password/:id"
            name="forget pass"
            element={<ForgetPassPage />}
          />
          <Route
            exact
            path="/verify-email/:emailcode"
            name="verifyEmail"
            element={<VerifyEmail />}
          />
          <Route
            exact
            path="/forgotpassword"
            name="ForgotPassword Page"
            element={<ForgetPassUser />}
          />
          <Route
            exact
            path="/reset-password/:id"
            name="forget pass"
            element={<ForgetPassUserPage />}
          />
          <Route
            exact
            path="/teacher/profilereview"
            name="ProfileReview"
            element={<ProfileReview />}
          />
          <Route
            exact
            path="/career/details/:id"
            name="careerdetails"
            element={<ViewCarrerDetails />}
          />
          <Route exact path="/meeting/:id" name="Meeting" element={<Meeting />} />
          <Route exact path="/500" name="Page 500" element={<Page500 />} />
          <Route exact path="/orderwithus" name="Order With Us" element={<OrderWithUs />} />
          <Route
            exact
            path="/orderwithusList"
            name="Order With Us List"
            element={<OrderwithusList />}
          />
          <Route exact path="/Ordersearch" name="Order Search " element={<Ordersearch />} />
          <Route exact path="/headerarticle" name="Header Article " element={<HeaderArticle />} />
          <Route
            exact
            path="/readmorearticle/:id"
            name="Readmore Article "
            element={<ReadmoreArticle />}
          />
          <Route exact path="/seller-register" name="SellerRegister" element={<SellerRegister />} />
          <Route exact path="/seller-login" name="SellerLogin" element={<SellerLogin />} />
          <Route exact path="/services" name="services" element={<StudentLanding />} />
          <Route
            exact
            path="/payment-callback"
            name="paymentmessage"
            element={<PaymentMessage />}
          />
          <Route exact path="/pricing" name="pricing" element={<StudentPricing />} />
          <Route exact path="/careers" name="studentcareers" element={<Careers />} />
          <Route exact path="/aboutus" name="aboutus" element={<AboutUs />} />
          <Route exact path="/checkout?" name="checkoutplan" element={<Checkout />} />
          <Route
            exact
            path="/user/changepassword"
            name="ChangePassword"
            element={<StudentChangePassword />}
          />
          <Route
            exact
            path="/copyrightpolicy"
            name="CopyRightPolicy"
            element={<CopyRightPolicy />}
          />
          <Route
            exact
            path="/copyrighttakedownrequest"
            name="CopyrightTakedownRequest"
            element={<CopyrightTakedownRequest />}
          />
          <Route
            exact
            path="/generalpolicies"
            name="GeneralPolicies"
            element={<GeneralPolicies />}
          />
          <Route
            exact
            path="/honorcode"
            name="HonorCode"
            element={<HonorCode />}
          />
          <Route
            exact
            path="/teachercoolprivacypolicy"
            name="TeacherCoolPrivacyPolicy"
            element={<TeacherCoolPrivacyPolicy />}
          />
          <Route
            exact
            path="/termsofuse"
            name="TermsOfUse"
            element={<TermsOfUse />}
          />

          {/* Protected Routes - Require Authentication */}
          <Route
            exact
            path="/user/studentprofile"
            name="studentprofile"
            element={
              <Protected>
                <StudentProfile />
              </Protected>
            }
          />
          <Route
            exact
            path="/user/studentnotification"
            name="studentnotification"
            element={
              <Protected>
                <StudentNotification />
              </Protected>
            }
          />
          <Route
            exact
            path="/user/student/viewassignments/:id"
            name="StudentAssignmentView"
            element={
              <Protected>
                <StudentViewAssignments />
              </Protected>
            }
          />
          <Route
            exact
            path="/user/orders"
            name="studentorder"
            element={
              <Protected>
                <StudentOrder />
              </Protected>
            }
          />
          <Route
            exact
            path="/studentdashboard/home"
            name="studentorderHome"
            element={
              <Protected>
                <Home />
              </Protected>
            }
          />
          <Route
            exact
            path="/studentdashboard/chat"
            name="studentorderChat"
            element={
              <Protected>
                <Chat />
              </Protected>
            }
          />
          <Route
            exact
            path="/managepayment/invoice"
            name="Home"
            element={
              <Protected>
                <PaymentInvoice />
              </Protected>
            }
          />
          <Route
            exact
            path="/studentdashboard/askquestion"
            name="studentorderAskQuestion"
            element={
              <Protected>
                <Question />
              </Protected>
            }
          />
          <Route
            exact
            path="/studentdashboard/rewards"
            name="studentorderRewards"
            element={
              <Protected>
                <Rewards />
              </Protected>
            }
          />

          {/* Default Route - Must be last */}
          <Route path="*" name="Home" element={<DefaultLayout />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  )
}

export default App